'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _underscore = require('underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIModal = require('UIComponents/dialog/UIModal');

var _UIModal2 = _interopRequireDefault(_UIModal);

var _UIDialogCloseButton = require('UIComponents/dialog/UIDialogCloseButton');

var _UIDialogCloseButton2 = _interopRequireDefault(_UIDialogCloseButton);

var _UIDialogBody = require('UIComponents/dialog/UIDialogBody');

var _UIDialogBody2 = _interopRequireDefault(_UIDialogBody);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _PromptablePropInterface = require('UIComponents/decorators/PromptablePropInterface');

var _PromptablePropInterface2 = _interopRequireDefault(_PromptablePropInterface);

var _connectMon084CommunicationMethods = require('ui-addon-upgrades/_core/communicationMethods/connectMon084CommunicationMethods');

var _connectMon084CommunicationMethods2 = _interopRequireDefault(_connectMon084CommunicationMethods);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommunicationMethodsModal = function (_React$Component) {
  _inherits(CommunicationMethodsModal, _React$Component);

  function CommunicationMethodsModal() {
    _classCallCheck(this, CommunicationMethodsModal);

    return _possibleConstructorReturn(this, (CommunicationMethodsModal.__proto__ || Object.getPrototypeOf(CommunicationMethodsModal)).apply(this, arguments));
  }

  _createClass(CommunicationMethodsModal, [{
    key: 'renderCommunicator',
    value: function renderCommunicator() {
      var _props = this.props,
          selectedMethodComponent = _props.selectedMethodComponent,
          buttonComponents = _props.buttonComponents,
          _overrideModalHeaderText = _props._overrideModalHeaderText;


      if (selectedMethodComponent) {
        return _react2.default.createElement(
          'div',
          null,
          selectedMethodComponent
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h1',
          { className: 'm-bottom-8' },
          _overrideModalHeaderText || _react2.default.createElement(_FormattedMessage2.default, { message: 'upgrades.communicationMethods.title' })
        ),
        _react2.default.createElement(
          _UIFlex2.default,
          { justify: 'center' },
          buttonComponents || _react2.default.createElement(_UILoadingSpinner2.default, null)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          onReject = _props2.onReject,
          onCancel = _props2.onCancel,
          buttonComponents = _props2.buttonComponents;

      var propsToPass = (0, _underscore.omit)(this.props, ['onReject', 'onConfirm', 'upgradeData', 'buttonComponents', 'selectedMethodComponent', 'upgradeComponent', '_overrideModalHeaderText']);

      return _react2.default.createElement(
        _UIModal2.default,
        _extends({
          width: 550 + (buttonComponents ? buttonComponents.length - 2 : 0) * 100,
          use: 'conversational'
        }, propsToPass, {
          onOverlayClick: function onOverlayClick() {
            onReject();
            onCancel();
          }
        }),
        _react2.default.createElement(_UIDialogCloseButton2.default, {
          onClick: function onClick() {
            onReject();
            onCancel();
          }
        }),
        _react2.default.createElement(
          _UIDialogBody2.default,
          { className: 'p-bottom-10' },
          this.renderCommunicator()
        )
      );
    }
  }]);

  return CommunicationMethodsModal;
}(_react2.default.Component);

CommunicationMethodsModal.defaultProps = {
  onCancel: function onCancel() {}
};


CommunicationMethodsModal.propTypes = _extends({}, _PromptablePropInterface2.default, {
  buttonComponents: _react.PropTypes.array,
  selectedMethodComponent: _react.PropTypes.node,
  upgradeComponent: _react.PropTypes.node
});

exports.default = (0, _connectMon084CommunicationMethods2.default)(CommunicationMethodsModal, {
  onDark: false,
  buttonType: 'selectableButton'
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/communicationMethods/CommunicationMethodsModal.js
// module id = 552
// module chunks = 3 4 5